import { DashboardTimeFrame } from 'containers/dashboard/types/types';

export const defaultActiveEquipmentDashboardCardTimeFrame: DashboardTimeFrame = 'pastFourteen';
